angular.module('admin')
  .controller('OfficeNavCtrl', ['$scope', '$state', 'AccountService', 'FEATURES'
    , function($scope, $state, AccountService, FEATURES){

    $scope.accountService = AccountService;

    $scope.getId = function(){
      return $state.params.id;
    };

    $scope.pageTitle = function(){
      if($state.current.data && $state.current.data.pageTitle)
        return $state.current.data.pageTitle;
      else if($scope.accountService.hasFeature(FEATURES.ADMIN))
        return 'Companies';
      else
        return 'Your Offices';
    };

    $scope.backurl = function(){
      if($state.current.data && $state.current.data.back)
        return $state.href($state.current.data.back, {id: $scope.getId()});
      else
        return false;
    };
  }]);
